
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/progetti",
      function () {
        return require("private-next-pages/progetti/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/progetti"])
      });
    }
  